import {BaseUserFlow, UserFlowList, UserFlowStep} from './BaseUserFlow';
import {UserFlowType} from './UserFlowFacade';
import {ROUTE_ASSISTANT} from '../../Constants';

export class FromAssistantUserFlow extends BaseUserFlow {
  protected readonly type = UserFlowType.FromAssistant;
  protected readonly canCancel = false;

  public setNextStep() {
    return super.setNextStep();
  }

  /**
   * @inheritdoc
   */
  public configure(): UserFlowList {
    super.configure();

    const newSteps: UserFlowList = [];

    if (`#/${ROUTE_ASSISTANT}/` !== this.designerSettings.project.stage) {
      // Not opened as an assistant so nothing needed.
      return newSteps;
    }

    const upgradePrompt = this.getPromptUpgradeOnOpen();
    if (null !== upgradePrompt) {
      newSteps.push(`${UserFlowType.Upgrade}.${UserFlowStep.Upgrade}`);
    }

    const optionsAndExtras = this.getOptionsAndExtrasOnOpen();
    if (null !== optionsAndExtras) {
      newSteps.push(`${UserFlowType.OptionsAndExtras}.${UserFlowStep.OptionsAndExtras}`);
    }

    return newSteps;
  }
}
